import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';

import { components } from '../../config/components';

import ForceSetContents from '../../containers/Sidebar/ForceSetContents';
import SaveTemplate from '../../containers/Sidebar/SaveTemplate';
import { getPathAfterBuild } from '../../util/file';

function AddContent() {

	const { isStandard } = useSelector((state: RootState) => state.auth.service);
	const { id } = useSelector((state: RootState) => state.auth.user);
	const { from, options } = useSelector((state: RootState) => state.auth.account);

	const [list, setList] = useState([] as any);
	const [jsonTitle, setJsonTitle] = useState('');

	useEffect(() => {
		let showCondition = 'all';
		if (isStandard) { showCondition += ' standard' }
		if (from === 'DONUS') { showCondition += ' donation' }
		
		const filteredComponents = components.filter((item) => {
			// 기본 plan 필터링
			if (!showCondition.includes(item.plan)) {
				return false;
			}
			
			// 네이버 광고는 추가로 advertiser.enabled 체크
			if (item.text === 'naverAd') {
				return options?.advertiser?.enabled === true;
			}
			
			return true;
		});
		
		setList(filteredComponents);

	}, [from, isStandard, options])

	const componentImage = (path) => {
		const context = require.context('../../assets/images/components', true);
		return getPathAfterBuild(context, path);
	}

	const onDragStart = (e:any) => {
		e.dataTransfer.setData("text", e.target.id);
	}

	return (
		<div className="editor-sidebar-add-content-wrapper">
			<div className="editor-sidebar-add-content">
				{
					list.map((item: any, index: number) => (
						<div className="add-content-item" key={index} >
							<div
								id={`${item.text}`}
								draggable="true"
								onDragStart={onDragStart}
								className="handle"
								style={{ backgroundImage: `url(${componentImage(`./${item.text}.png`)})` }}
							>
							<div className="title">
								{item.name}
							</div>
						</div>
						</div>
					))
				}
			</div>
			{
				id === 'jihyeon+template@stibee.com' && (
					<SaveTemplate />
				)
			}
			{
				(['jihyun@stibee.com', 'youngrong@stibee.com', 'suyeon@stibee.com', 'yeokyung@stibee.com', 'seunghee@stibee.com'].includes(id)) && (
					<ForceSetContents />
				)
			}
		</div>
	);
}

export default AddContent;